import React from "react";
import Productpage from "../../productpage2";

import SEO from "../../seo";

export default function ChiroChargePTPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-04.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-01.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-02.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-03.png",
    ],
    productName: "Chiro Charge PT",
    // productLogo:
    //   "https://eclipsemattress.in/wp-content/uploads/2021/06/Eclipse_sub-brand_logo-02.png",
    descriptionTitle: "POCKET PILLOW TOP",
    descriptionText:
      "Chiro Charge PT by Eclipse' is an avant grade product for the hotel industry, Decked with pocketed springs superior fillings and finest upholstery, this mattress will make you fall in love with its ergonomic sleeping experience. It's aesthetic value and comfort is unmatched in the hospitality industry.",
    // availableSizes: "6″, 8″ & 10",
    category: { title: "Hospitality Series", link: "/hospitality/" },
    points: [
      "HD Eclipse Pure foam",
      "High tensile pocketed springs at core",
      "Pillow Top Construction",
      "Highest US Bedding Standards followed",
      "Medium-Firm mattress",
    ],

    featuresText: [
      "HD Eclipse Soft Foam for quilting",
      "HD Eclipse Plush Foam",
      "Imported Turkish",
      // "PP Mesh for durability",
      "Stonger border wire construction with butterfly M-Springs as edge support on perimeter",
      "Pocketed Spring System",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-06.png",

    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-07.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-08.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-09.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-10.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-11.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-13.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-14.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-15.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-16.png",
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-12.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/chiro-charge-pt/CHIRO-charge-pt-05.png",
    // price: "₹34,399 - ₹1,01,799",
    relatedProducts: [
      {
        title: "Chiro Elite",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-elite.jpg",
        link: "/hospitality/chiro-elite/",
      },
      {
        title: "Chiro Charge",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-charge.jpg",
        link: "/hospitality/chiro-charge/",
      },
      {
        title: "Chiro Coil",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/chiro-coil.jpg",
        link: "/hospitality/chiro-coil/",
      },
    ],
    color: "#EFE5D8",
  };

  return (
    <div>
      <SEO
        title="Chiro Charge PT | Hospitality Series | Eclipse Mattress"
        description="Avant garde mattress with pocketed springs, finest upholstery and ergonomic sleeping experience for unmatched aesthetic value and comfort in the hospitality industry."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-chirochargept.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
